import { render, staticRenderFns } from "./StoreProduct.vue?vue&type=template&id=7b6d21be&scoped=true"
import script from "./StoreProduct.vue?vue&type=script&lang=js"
export * from "./StoreProduct.vue?vue&type=script&lang=js"
import style0 from "./StoreProduct.vue?vue&type=style&index=0&id=7b6d21be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6d21be",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QSeparator,QList,QItem,QItemSection,QBtn});
